export default function BenefitsSection() {
  const benefits = [
    {
      icon: 'ri-sun-line',
      title: 'Prostota',
      desc: 'Intuicyjny interfejs usfansspreadsheet sprawia, że zarządzanie danymi jest proste i przyjemne nawet dla początkujących użytkowników.',
    },
    {
      icon: 'ri-loop-left-line',
      title: 'Aktualizacje',
      desc: 'Regularne aktualizacje usfansspreadsheet zapewniają dostęp do najnowszych funkcji i poprawek bezpieczeństwa przez cały czas.',
    },
    {
      icon: 'ri-shield-star-line',
      title: 'Bezpieczeństwo',
      desc: 'usfansspreadsheet stosuje zaawansowane szyfrowanie SSL i przestrzega standardów RODO dla pełnej ochrony Twoich danych.',
    },
    {
      icon: 'ri-stack-line',
      title: 'Organizacja danych',
      desc: 'Dzięki usfansspreadsheet możesz uporządkować wszystkie swoje dane w jednym miejscu, oszczędzając czas i zwiększając produktywność.',
    },
  ];

  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <p className="text-xs font-semibold text-primary-600 uppercase tracking-wider mb-3">
            Korzyści
          </p>
          <h2 className="font-heading text-3xl md:text-4xl text-foreground-950 leading-tight max-w-2xl mx-auto">
            Dlaczego użytkownicy wybierają usfansspreadsheet?
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {benefits.map((benefit) => (
            <div
              key={benefit.title}
              className="group p-6 rounded-2xl bg-background-100 border border-background-200/60 hover:bg-background-50 hover:border-accent-200/60 transition-all duration-300"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary-100 mb-4 group-hover:bg-primary-200 transition-colors">
                <i className={`${benefit.icon} text-lg text-primary-600`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2">{benefit.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{benefit.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}